// @flow

import type { PendingIncomingPayment } from './types';
import { getGateway } from '@tectonics/prs/gateway';

export function getGatewayVoucherUrl(incomingPayment: PendingIncomingPayment): string {
  const gateway = getGateway(incomingPayment);
  return gateway['voucher_url'];
}
